import React from 'react';
import ExcelManager from '../components/History/ExcelManager';

const ExcelConfigPage = () => {
  return <ExcelManager />;
};

export default ExcelConfigPage;